import { defineComponent as _defineComponent } from 'vue'
import IconVisibilityOn from "@busy-human/hxp-library/resources/icons/visibility_on.svg";
import IconVisibilityOff from "@busy-human/hxp-library/resources/icons/visibility_off.svg";
import { computed, ref } from "vue";

type Props = {
    allowShow?: boolean
    modelValue: string
    placeholder?: string
}
type Emits = {
    (e: "update:modelValue", modelValue: Props["modelValue"]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'password',
  props: {
    allowShow: { type: Boolean },
    modelValue: {},
    placeholder: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const hidePassword = ref(true);
const visibleIcon = computed(() => hidePassword.value ? IconVisibilityOff : IconVisibilityOn);
const inputType = computed(() => hidePassword.value ? "password" : "text")
const toggleVisibility = () => {
    if(props.allowShow) {
        hidePassword.value = !hidePassword.value;
    }
}


const local = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})


const __returned__ = { props, emit, hidePassword, visibleIcon, inputType, toggleVisibility, local, get IconVisibilityOn() { return IconVisibilityOn }, get IconVisibilityOff() { return IconVisibilityOff }, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})